module.exports = __webpack_public_path__ + "static/media/btn_secondaryschool_02_Socialmediauserguide.900ef33e.png";